// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2J3eJ","colMin":"styles_colMin__zpQ5O","colCheckbox":"styles_colCheckbox__2JiNm"};